import axios from 'axios';

export const TOKEN_KEY = 'am.token';
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api/v1', timeout: 20000 });

export const setToken = (t) => {
  if (t) {
    localStorage.setItem(TOKEN_KEY, t);
    api.defaults.headers.common.Authorization = `Bearer ${t}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common.Authorization;
  }
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);
const saved = getToken();
if (saved) api.defaults.headers.common.Authorization = `Bearer ${saved}`;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (status === 401 && getToken()) window.dispatchEvent(new Event('am:unauthorized'));
    const e = new Error(err.response?.data?.message || (err.code === 'ECONNABORTED' ? 'The server took too long to answer' : err.message) || 'Request failed');
    e.status = status;
    return Promise.reject(e);
  }
);

export default api;
